<template>
  <v-layout justify-center>
    <v-flex shrink>
      <v-pagination v-if="length > 1" v-model="model" :length="length" total-visible="10" />
      <div
        v-else-if="!hideMessage && !loadingCategoryItems"
        class="font-italic font-weight-light grey--text mt-3"
      >No hay más items que mostrar</div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    hideMessage: { default: false, type: Boolean }
  },
  computed: {
    /* The computed variable to use in the v-model to sync the page */
    model: {
      set(page) {
        this.setCategoryItemsPage(page);
      },
      get() {
        return this.categoryItemsPage;
      }
    },
    ...mapState("classifier", [
      "categoryItemsCount",
      "categoryItemsFetch",
      "categoryItemsPage",
      "loadingCategoryItems"
    ]),
    length() {
      return Math.ceil(this.categoryItemsCount / this.categoryItemsFetch);
    }
  },
  methods: {
    ...mapActions("classifier", ["setCategoryItemsPage"])
  }
};
</script>
